<template>
  <div class="thumbnail-container w100 h100">
    <div class="thumbnail flex-c w100 h100">
      <img draggable="false" v-if="bgUrl" @load="handleStampLoaded" :class="is916 ? 'w100' : 'h100'" :src="bgUrl" />
      <div class="processing" v-else-if="isProcessing"></div>
      <i class="fs-30" :class="typeIcon" v-else></i>
    </div>
    <div class="scrubber-container flex w100 h100" v-if="scrubUrl">
      <div class="scrubber-image relative" :class="is916 ? '' : 'h100'"
        :style="{ aspectRatio: stampAspectRatioStr }"
        @mousemove.self="handleScrubMove">
        <div class="abs-center scrub-win h100" :style="{ aspectRatio: stampAspectRatioStr }">
          <img draggable="false" @load="handleScrubLoaded" class="scrubber-image-container" :src="scrubUrl"
            :style="{ left: `${x}px`, top: `${y}px`, height: scrubHeight, width: scrubWidth }" />
        </div>
        <div class="scrubber-bar h100" :style="{ left: `${offsetX}px` }"></div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, nextTick, onMounted, onUnmounted, ref, toRefs, watch } from 'vue';
import { Asset, FileStatus } from '@/types'
import { div, mul } from '@/utils/utils';
import { isAudio, isFolder, isNote, isPicture, isProject, isVideo } from '@/utils/bussiness';

const iconMap = {
  video: 'ri-video-line',
  audio: 'ri-music-line',
  other: 'ri-file-line',
  folder: 'ri-folder-3-line',
  project: 'project-icon',
  live: 'ri-live-line',
  img: 'ri-image-line',
  note: 'ri-presentation-line'
}
const props = withDefaults(defineProps<{
  file: Asset,
  aspectRatio?: number,
}>(), {
  aspectRatio: 16 / 9
})
const { file, aspectRatio } = toRefs(props)

watch(aspectRatio, () => {
  nextTick(clacScrubSize)
})

const is916 = computed(() => {
  return aspectRatio?.value === 9 / 16
})
const bgUrl = computed(() => file.value.media?.thumbnail_path)
const typeIcon = computed(() => {
  if (isFolder(file.value)) {
    return iconMap.folder
  } else if (isVideo(file.value)) {
    return iconMap.video
  } else if (isAudio(file.value)) {
    return iconMap.audio
  } else if (isPicture(file.value)) {
    return iconMap.img
  } else if (isProject(file.value)) {
    return iconMap.project
  } else if (isNote(file.value)) {
    return iconMap.note
  } else {
    return iconMap.other
  }
})
const scrubUrl = computed(() => (file.value).media?.slide_thumbnail_path)
const isProcessing = computed(() => !isFolder(file.value) && (!file.value.media))

const offsetX = ref(0)
const x = ref(0)
const y = ref(0)
const xMax = 10
const yMax = 3
const scrubWidth = ref('100%')
const scrubHeight = ref('auto')
const stampAspectRatioStr = ref('16/9')
let stampAspectRatio = 16 / 9
const handleScrubMove = (e: MouseEvent) => {
  offsetX.value = e.offsetX
  if (scrubImgLoaded && stampEle) {
    clacScrubSize()
    // const stampRect = stampImg!.getBoundingClientRect()
    const totalCount = xMax * yMax
    const rect = (e.currentTarget as HTMLDivElement).getBoundingClientRect()
    const index = Math.floor(div(mul(totalCount, e.offsetX), rect.width))
    x.value = -1 * mul(rect.height * stampAspectRatio, index % xMax)
    y.value = -1 * mul(rect.height, Math.floor(index / xMax))
  }
}
let scrubImgLoaded = false
let stampEle: HTMLImageElement | null = null

const handleScrubLoaded = (e: Event) => {
  scrubImgLoaded = true
}
const handleStampLoaded = (e: Event) => {
  stampEle = e.target as HTMLImageElement
  clacScrubSize()
}
const clacScrubSize = () => {
  if (stampEle) {
    const rect = stampEle!.getBoundingClientRect()
    scrubWidth.value = rect.width * xMax + 'px'
    scrubHeight.value = rect.height * yMax + 'px'
    stampAspectRatioStr.value = `${rect.width}/${rect.height}`
    stampAspectRatio = rect.width / rect.height
  }
}
onMounted(() => {
  window.addEventListener('resize', clacScrubSize)
})
onUnmounted(() => {
  window.removeEventListener('resize', clacScrubSize)
})
</script>

<style lang="stylus" scoped>
.thumbnail-container {
  position: relative;
  overflow: hidden;
  &:hover .scrubber-container{
    opacity: 1;
  }
}
.thumbnail {
  background-repeat: no-repeat;
  background-position: top;
  background-size: contain;
  border-radius: 6px;
  background-color:#30313e;
}


.scrubber-container {
  position: absolute;
  top: 0;
  transform: translateZ(0)
  opacity: 0;
}

.scrubber-image-container {
  pointer-events: none;
  position: absolute;
}

.scrubber-container:hover .scrubber-bar {
  opacity: 1!important
}

.scrubber-container .scrubber-image {
  background-size: cover;
  overflow: hidden
  width: 100%
}

.scrub-win {
  overflow: hidden;
  pointer-events: none;
}

.scrubber-container .scrubber-image .scrubber-image-container {
  background-position: 50%;
  background-size: cover;
  background-repeat: no-repeat
}

.scrubber-container .scrubber-bar {
    background-color: #e95252;
    width: 2px;
    // height: inherit;
    top: 0;
    left: 0;
    position: absolute;
    pointer-events: none;
    opacity: 0
}

.project-icon {
  display: inline-block;
  width: 30px;
  height: 30px;
  background: url(../../../public/img/premiere.svg)
}

.processing {
  border: 1px solid rgb(91, 83, 255);
  border-radius: 50%;
  height: 30px;
  width: 30px;
  animation: 0.6s ease-in-out 0s infinite alternate none running scale;
}

@keyframes scale {
    0% {
        transform: scale(.8)
    }

    to {
        transform: scale(1)
    }
}
</style>